var product = document.querySelector('.product__main');
var productDescription = product.querySelector('.product__description');
var seeFullDetailsTrigger = productDescription.querySelector('.description-collapsible--trigger');
var descriptionCollapsible = productDescription.querySelector('.description-collapsible');

if(productDescription && seeFullDetailsTrigger) {
    if (seeFullDetailsTrigger.classList.contains('hidden')) seeFullDetailsTrigger.classList.remove('hidden');
}

seeFullDetailsTrigger?.addEventListener("click", function () {
    if (descriptionCollapsible.classList.contains('description-collapsible--hidden')) descriptionCollapsible.classList.remove('description-collapsible--hidden');
    if (!seeFullDetailsTrigger.classList.contains('hidden')) seeFullDetailsTrigger.classList.add('hidden');
});

var upsellTabs = document.querySelectorAll('.product__upsell-tab');
var upsellPanels = document.querySelectorAll('.product__upsell-panel');

upsellTabs.forEach(function (tab) {
    tab?.addEventListener("click", function(e) {
        upsellTabs.forEach(function (t) {
            if(t.classList.contains('product__upsell-tab--active')) t.classList.remove('product__upsell-tab--active');
        });
        if (!e.target.classList.contains('product__upsell-tab--active')) {
            e.target.classList.add('product__upsell-tab--active');
            upsellPanels.forEach(function (panel) {
                if (e.target.dataset.tab === panel.dataset.panel) {
                    if(!panel.classList.contains('product__upsell-panel--active')) panel.classList.add('product__upsell-panel--active');
                } else {
                    panel.classList.remove('product__upsell-panel--active');
                }
            });
        }
    });
});

var upsellAddToBag = document.querySelectorAll('.upsell-product-card .upsell-product-card__add-to-bag[data-add-to-bag]');

upsellAddToBag.forEach(function (button) {
    button?.addEventListener("click", function(e) {
        let item = {
            id: e.target.dataset.variantId,
            quantity: 1
        }
        VueMinicart.config.globalProperties.$store.dispatch('addItem', item);    
    });
});

window.addEventListener("load", () => {
    const referrer = document.referrer;
    const hash = window.location.hash;

    const validReferrers = [
        "/pages/founder-long",
        "/pages/founder-short"
    ];

    const fromLanding = validReferrers.some(path => referrer.includes(path));

    if (fromLanding && hash === "#okendo-wrap") {
        setTimeout(() => {
            const el = document.querySelector("#okendo-wrap");
            if (!el) return;

            el.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });

            history.replaceState(null, "", window.location.pathname + window.location.search);
        }, 800);
    }
});